import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const getMenuPageData = createAsyncThunk(
    "menuPage/getMenuPageData",
    async () => {
        const { data } = await axios.get("https://www.api.lalibela.be/api/base/menuPageData/")
        return data;
    }
)

const initialState = {
    isLoading: false,
    isError: false,
    error: "",
    success: false,
    menuPageData: [],
}

const menuPageDataSlice = createSlice({
    name: "menuPage",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getMenuPageData.pending, (state) => {
            state.isLoading = true
        })

        builder.addCase(getMenuPageData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.menuPageData = action.payload;
            state.success = true;
        })

        builder.addCase(getMenuPageData.rejected, (state) => {
            state.isLoading = false;
            state.isError = true;
            state.error = "Request failed with status code 404!"
        })
    }
})

export default menuPageDataSlice.reducer;